import React from "react";
import { observer } from "mobx-react-lite";
import Select from "react-select";

const BrandSelect = observer(({ store }) => {
    const customStyles = {
        control: (base) => ({
            ...base,
            borderRadius: "0px",
            border: "solid  #dddddd 2px",
        })
    }

    return (<>
            <Select
                sm={10}
                aria-labelledby="brand-label"
                className="react-select-container brand_input"
                classNamePrefix="react-select"
                options={store?.options()}
                id="selected"
                value={store?.selected}
                // onInputChange={(data) => store?.search(data)}
                onChange={(data) => store?.select(data)}
                getOptionLabel={option => option.label}
                getOptionValue={option => option.uuid}
                placeholder="Select"
                styles={customStyles}
                isMulti={false}
            />
        </>
    );
});

export default BrandSelect;
